import { useEffect, useState } from "react";
import { Scale } from "lucide-react";
import { api } from "@/lib/api";

// Under the title of a Trending political issues page: one chip per debated topic, straight to its Middle perspective.
export const TopicChips = ({ liveId, onPick }) => {
  const [topics, setTopics] = useState([]);
  useEffect(() => { api.get(`/live/${liveId}/topics`).then((r) => setTopics(r.data.topics || [])).catch(() => {}); }, [liveId]);
  if (!topics.length) return null;
  return (
    <div className="space-y-2" data-testid="topic-chips">
      <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-[hsl(var(--facts))]"><Scale size={13} />Middle's perspective on what may decide the next election</p>
      <div className="flex flex-wrap gap-2">
        {topics.map((t, i) => (
          <button key={t.topic} type="button" onClick={() => onPick(i)} data-testid={`topic-chip-${i}`}
            className="rounded-full border border-[hsl(var(--facts)/0.3)] bg-white px-3 py-1.5 text-sm font-medium text-slate-800 transition-colors hover:border-[hsl(var(--facts))] hover:bg-[hsl(var(--facts)/0.06)]">{t.topic}</button>
        ))}
      </div>
    </div>
  );
};
